import type { GQL_ID } from '@@partner:types:graphql'
import type { OrderInfo } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import {
  ORDER_FIELDS,
  ORDER_PRODUCTS_ALL_FIELDS,
  ORDER_SHOP_FIELDS,
  ORDER_TOTALS_FIELDS,
  SHORTCUT_DELIVERY_CLAIM_FEILDS,
  SHORTCUT_ORDER_RECEIPT_FIELDS
} from '@@partner:graphql/shortcuts'

export interface OrderQueryVariables {
  order_id: GQL_ID
  style: string
}
export interface OrderQuery {
  order: OrderInfo
}

export const GQL_QUERY_ORDER = gql`
  query($order_id: ID!, $style: String) {
    order(order_id: $order_id) {
      ${ORDER_FIELDS}
      ${ORDER_TOTALS_FIELDS}
      ${ORDER_SHOP_FIELDS}
      ${ORDER_PRODUCTS_ALL_FIELDS}
      assemblingSide
      shippingSide
      status
      isPaid
      customer_phone
      assembler {
        id
        first_name
        last_name
        phone
      }
      courier {
        id
        first_name
        last_name
        phone
      }
      customerGeoPoint {
        latitude
        longitude
      }
      recipientInfo {
        firstName
        lastName
      }
      promocode {
        id
        code
      }
      deliverySlot {
        id
        slotTime
        slotDate
      }
      deliveryClaims {
        ${SHORTCUT_DELIVERY_CLAIM_FEILDS}
      }
      receipts {
        ${SHORTCUT_ORDER_RECEIPT_FIELDS}
      }
      feedbacks {
        id
        brand_id
        order_id
        review
        general_rating
        assemble_rating
        shipping_rating
        product_rating
        need_call
        images(style: $style) {
          url
        }
        # customer
      }
      payments {
        id
        status
        payment_id
        payment_type
        paid
        sum
        operation
        cancel_by
        cancel_reason
        created_at
      }
      paymentMethod {
        id
        type
        card
        last
        country
        pluginId
        isDefault
      }
      assignedCustomerId
      receipt_email

      placedAt
      assemblingStartedAt
      assemblingFinishedAt
      pickedByCourierAt
      deliveryStartedAt
      deliveryFinishedAt
    }
  }
`

/*
  Load all fields
*/

export const useFetchSingleOrder = (order_id: GQL_ID, style = '1200xauto') => {
  return useQuery<OrderQuery, OrderQueryVariables>(GQL_QUERY_ORDER, {
    variables: {
      order_id,
      style
    },
    fetchPolicy: 'network-only'
  })
}
